<template>
    <div class="w-full grid grid-cols-2 items-center gap-1">
        <label :for="id" class="text-white" style="color: var(--label);">{{ label }}</label>
        <select
            :id="id"
            class="rounded-md p-1"
            :placeholder="placeholder"
            :value="modelValue"
            @change="$emit('update:modelValue', $event.target.value)"
            :class="{ 'input-required': isEmptyField() }"
            >
            <!-- :class="{ 'red-border': isEmptyField('modelValue') }"  -->
            <option disabled value="">{{ placeholder }}</option>
            <option v-for="option in options" :key="option.id" :value="option.id">
                {{ option.nome }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        label: String,
        modelValue: [String, Number],
        options: Array,
        placeholder: String
    },
    methods: {
        isEmptyField() {
  return (this.modelValue || '').toString().trim() === '';
}
        // j.. 04_04 Troque a fun��o isEmptyField() para trabalhar diretamente com modelValue, e garanta que ele seja tratado como string
        // isEmptyField(field) {
        //     return !this[field] || this[field].trim() === '';
        // }
    },
};
</script>


<style scoped>
</style>
